/**
 * Cart Upsell Tracking
 * 
 * Listens for successful add-to-cart events from upsell forms and sets
 * cart attributes to tag the order. Cart attributes propagate to the order
 * and are visible in Shopify admin for filtering/reporting.
 *
 * Sets: _upsell_used = "true", _upsell_types = "upgrade,add_on,goes_well_with"
 * (underscore prefix hides from customer but visible in admin)
 */
(function () {
  function getUpsellTypeFromEvent(event) {
    if (!event || !event.target) return null;
    const form = event.target.closest('[data-upsell-type]');
    return form ? form.dataset.upsellType : null;
  }

  function updateCartAttributes(upsellType) {
    // Fetch current cart to check existing attributes
    fetch('/cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var currentTypes = (cart.attributes && cart.attributes['_upsell_types']) || '';
        var typesArray = currentTypes ? currentTypes.split(',') : [];

        if (typesArray.indexOf(upsellType) === -1) {
          typesArray.push(upsellType);
        }

        var attributes = {
          '_upsell_used': 'true',
          '_upsell_types': typesArray.join(',')
        };

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function (e) {
        console.warn('[upsell-tracking] Failed to update cart attributes:', e);
      });
  }

  // Listen for form submissions on upsell forms
  document.addEventListener('submit', function (event) {
    var upsellForm = event.target.closest('[data-upsell-type]');
    if (!upsellForm) return;

    var upsellType = upsellForm.dataset.upsellType;
    if (!upsellType) return;

    // Delay slightly to let the add-to-cart complete first
    setTimeout(function () {
      updateCartAttributes(upsellType);
    }, 1000);
  });
})();
